<template>
  <div class="layout">
    <div class="layout_nav">
      <Nav v-bind="getRol"></Nav>
    </div>
    <SkeletonDevice v-if="loadBar == true"></SkeletonDevice>
    <div v-else class="layout_center">
      <div class="layout_row">
        <div class="layout_colum">
          <div class="ctn_bread">
            <Welcome v-bind="getUser"></Welcome>
            <router-link class="bread" :to="{ name: 'NetworkHome' }"
              >/Integradores</router-link
            >
          </div>
        </div>
        <div class="layout_colum">
          <Snackbar
            v-bind:visible="getAlert.snackbar"
            v-bind:text="getAlert.text"
          ></Snackbar>
        </div>
      </div>
      <div v-if="this.getQueyIntegrator != null">
        <div class="data_device_page">
          <div class="data_device_page_colum medium_35">
            <div class="data_device_map">
              <l-map :zoom="this.zoom" :center="coorde" class="style_map">
                <l-tile-layer :url="url" :attribution="attribution" />
                <l-marker :lat-lng="coorde">
                  <l-popup>
                    <div>
                      {{ getQueyIntegrator.device.idx }}
                    </div>
                  </l-popup>
                </l-marker>
              </l-map>
            </div>
          </div>
          <div class="data_device_page_colum">
            <div class="data_device_indicator">
              <div class="item_indicator">
                <div>
                  <span
                    class="device_active"
                    v-if="getQueyIntegrator.activate == 1"
                    >Activo</span
                  >
                  <span class="device_inactive" v-else>Inactivo</span>
                </div>
                <div>
                  <span
                    class="device_active"
                    v-if="getQueyIntegrator.state == true"
                    >Conectado</span
                  >
                  <span class="device_inactive" v-else>Desconectado</span>
                </div>
              </div>
              <div
                v-if="getQueyIntegrator.device.infoNodo"
                class="item_indicator_battery"
              >
                <span
                  v-if="getQueyIntegrator.device.infoNodo.BatteryLevel == '255'"
                >
                  <v-icon>mdi-battery</v-icon>
                  {{
                    ((parseFloat(
                      getQueyIntegrator.device.infoNodo.BatteryLevel
                    ) *
                      100) /
                      255)
                      | battery
                  }}%
                </span>
                <span v-else>
                  <v-icon style="color: #f50">mdi-battery-50</v-icon>
                  {{
                    ((parseFloat(
                      getQueyIntegrator.device.infoNodo.BatteryLevel
                    ) *
                      100) /
                      255)
                      | battery
                  }}%
                </span>
              </div>

              <div class="item_indicator_actions">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="table_menu"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Acciones
                      <v-icon>mdi-menu-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item class="list_action">
                      <v-btn plain @click="editItem(getQueyIntegrator)"
                        >Editar</v-btn
                      >
                    </v-list-item>
                    <v-list-item class="list_action">
                      <v-btn
                        class="cent"
                        @click="
                          addDeviceItem({
                            _id: getQueyIntegrator._id,
                            _devices: getQueyIntegrator._devices,
                          })
                        "
                        plain
                        >Asociar</v-btn
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
            <div class="indicator_num">
              <div class="ind_logo">
                <p>
                  <b>{{ getQueyIntegrator.device.idx }}</b>
                </p>
                <img src="../../assets/img/electric-meter_1.svg" alt="" />
                <p>
                  <b>{{ getQueyIntegrator.device.subTypeService }}</b>
                </p>
              </div>
              <div class="indicator_num_display _medium">
                <p>Lectura Medidor</p>
                <p class="num_indi">
                  {{ getQueyIntegrator.device.CounterToday | twoDigit }}
                  {{ units }}
                </p>
                <div class="ctn_off_data">
                  <span
                    v-if="getQueyIntegrator.device.switch == true"
                    class="off_data online"
                    >Encendio</span
                  >
                  <span v-else class="off_data offline">Apagado</span>
                </div>
                <p>{{ getQueyIntegrator.name }}</p>
                <p>Nivel - {{ getQueyIntegrator.level }}</p>
              </div>
              <div class="indicator_num _columns _medium">
                <!-- mientras se define que hay en estos campos -->
                <!-- <div class="indicator_num_display _box">
                  <p>Consumo total</p>
                  <p class="text_normal">
                    {{ getQueyIntegrator.device.Counter | unitCounter
                    }}{{ units }}
                  </p>
                </div> -->
                <!-- <div class="indicator_num_display _box">
                  <p>Consumo del dia</p>
                  <p class="text_normal">
                    {{ getQueyIntegrator.device.CounterToday | unitCounter }}
                    {{ units }}
                  </p>
                </div> -->
              </div>
            </div>
            <div class="indicator_num">
              <div class="indicator_num_display _box _medium _movile">
                <div class="indi_integrator">
                  <p>Valor Integrador</p>
                  <h2>
                    {{ getQueyIntegrator.consumption.valIntegrator | twoDigit }}
                    {{ units }}
                  </h2>
                  <span class="display">{{
                    getLastUsageIntegrator.createDate
                  }}</span>
                </div>
              </div>
              <div class="indicator_num_display _box _medium _movile">
                <div class="indi_integrator">
                  <p>Valor Asociados</p>
                  <h2>
                    {{ getQueyIntegrator.consumption.valDisp | twoDigit }}
                    {{ units }}
                  </h2>
                  <span class="display"
                    >Dispositivos {{ getQueyIntegrator._devices.length }}</span
                  >
                </div>
              </div>
              <div class="indicator_num_display _box _medium _movile">
                <div class="indi_integrator">
                  <p>Diferencia porcentual</p>
                  <h2>
                    {{ getQueyIntegrator.consumption.valDifer | percent }}
                  </h2>
                  <span
                    v-if="getLastUsageIntegrator.check == true"
                    class="display alert"
                  >
                    <v-icon>mdi-alert-box</v-icon> Revisión</span
                  >
                  <div v-if="getLastUsageIntegrator.check == false">
                    <span
                      v-if="parseFloat(getLastUsageIntegrator.valDifer) < 0"
                      class="display warning"
                    >
                      Error</span
                    >
                    <span v-else class="display normal"> Normal</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section_history">
          <h4>HISTORIAL</h4>
          <v-select
            class="tab_header_select"
            v-model="tab"
            :items="itemSelect"
            item-value="id"
            item-text="name"
            label="Opciones historico"
          ></v-select>
          <v-tabs class="tab_header_custom" v-model="tab">
            <v-tab key="1">Consumos</v-tab>
            <v-tab key="2">Dispositivos</v-tab>
            <v-tab key="3">Notificaciones</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item key="1">
              <TableHistory></TableHistory>
            </v-tab-item>
            <v-tab-item key="2">
              <TableDevices
                :list="this.getQueyIntegrator._devices"
                :IdIntegrator="this.getQueyIntegrator._id"
              ></TableDevices>
            </v-tab-item>
            <v-tab-item key="3">
              <TableNotify
                :idDevice="getQueyIntegrator.device._id"
              ></TableNotify>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </div>
    <Edit
      :data="itemObjct"
      :visible="EditFlag"
      @close="EditFlag = false"
    ></Edit>
    <AddDevice
      :visible="AddDeviceFlag"
      :data="itemObjct"
      @close="AddDeviceFlag = false"
    ></AddDevice>
  </div>
</template>
<script>
import moment from "moment";
import { latLng, Icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { mapGetters, mapActions } from "vuex";
import Nav from "@/components/Nav.vue";
import Welcome from "@/components/Welcome.vue";
import Snackbar from "@/components/Snackbar.vue";
import TableHistory from "@/components/network/TableHistory.vue";
import TableDevices from "@/components/network/TableDevices.vue";
import Edit from "@/components/network/Edit.vue";
import AddDevice from "@/components/network/AddDevice.vue";
import SkeletonDevice from "@/components/SkeletonDevice.vue";
import TableNotify from "@/components/network/TableNotify.vue";
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
export default {
  name: "NetworkID",
  components: {
    Nav,
    Welcome,
    Snackbar,
    TableHistory,
    TableNotify,
    TableDevices,
    Edit,
    AddDevice,
    LMap,
    LTileLayer,
    LPopup,
    LMarker,
    SkeletonDevice,
  },
  data() {
    return {
      EditFlag: false,
      newFlag: false,
      AddDeviceFlag: false,
      itemObjct: {},
      tab: null,
      zoom: 17,
      menu: null,
      itemSelect: [
        { id: "1", name: "Lecturas" },
        { id: "2", name: "Notificaciones" },
        { id: "3", name: "Usuarios" },
        { id: "4", name: "Switch" },
        { id: "5", name: "Limite" },
        { id: "6", name: "Programado" },
        { id: "6", name: "Config" },
      ],
      users: [],
      withPopup: latLng(this.latNum, this.longNum),
      currentCenter: latLng(this.latNum, this.longNum),
      url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      showMap: true,
      currentZoom: 11.5,
      showParagraph: false,
    };
  },

  async mounted() {
    await this.QueryIntegrator(this.$route.params.id);
    this.users = await this.queryUserDevices(this.$route.params.id);
    this.SETupdate();
    this.$root.$on("reload", async () => {
      await this.QueryIntegrator(this.$route.params.id);
      this.users = await this.queryUserDevices(this.$route.params.id);
      this.SETupdate();
    });
  },
  methods: {
    ...mapActions([
      "QueryIntegrator",
      "QueryDevice",
      "queryUserDevices",
      "QueryDeviceNode",
    ]),
    addDeviceItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.AddDeviceFlag = true;
    },
    editItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.EditFlag = true;
    },
    SETupdate() {},
  },
  computed: {
    ...mapGetters([
      "getQueyIntegrator",
      "isLogin",
      "getUser",
      "getQueyDevice",
      "getQueyNode",
      "getAlert",
      "getRol",
      "isMaster",
    ]),
    loadBar() {
      if (this.getQueyIntegrator != null) {
        return false;
      } else {
        return true;
      }
    },
    /* getDataNow() {
      let array = this.getQueyIntegrator.device.dataStream;
      if (array.length > 0 && array != undefined && array != null) {
        let filter = array.slice(-1);
        let res = {
          value: filter[0].v,
          date: moment(filter[0].d)
            .locale("es")
            .fromNow(),
        };
        return res;
      }
      return "-";
    }, */
    getLastUsageIntegrator() {
      let array =
        this.getQueyIntegrator.consumption[
          this.getQueyIntegrator.consumption.length - 1
        ];
      if (array != undefined && array != null) {
        let filter = array;
        let res = {
          valIntegrator: filter.valIntegrator,
          valDisp: filter.valDisp,
          valDifer: filter.valDifer,
          check: filter.check,
          tolerance: filter.tolerance,
          createDate: moment(filter.createDate).locale("es").fromNow(),
        };
        return res;
      }
      return "-";
    },
    units() {
      let dataUnit = this.getQueyIntegrator.device.CounterToday;
      let units = dataUnit.slice(-3);
      return units;
    },
    latNum() {
      let lat = Number(this.getQueyIntegrator.device.latitude);
      return lat;
    },
    longNum() {
      let long = Number(this.getQueyIntegrator.device.longitude);
      return long;
    },
    coorde() {
      let res = latLng(this.latNum, this.longNum);
      return res;
    },
  },
  filters: {
    percent(val) {
      if (val != undefined) {
        //let units = val.slice(-3);
        return `${parseFloat(val).toFixed(2)} %`;
      } else {
        return `${parseFloat(0).toFixed(2)} %`;
      }
    },
    twoDigit(val) {
      if (val != undefined) {
        //let units = val.slice(-3);
        return `${parseFloat(val).toFixed(2)} `;
      } else {
        return `${parseFloat(0).toFixed(2)}`;
      }
    },
    unitCounter(val) {
      if (val != undefined) {
        //let units = val.slice(-3);
        return `${parseFloat(val).toFixed(2)} `;
      } else {
        return `${parseFloat(0).toFixed(2)}`;
      }
    },
    formatDate: (value) => {
      if (value) {
        return moment(value).locale("es").format("YYYY-MM-DD HH:mm");
      }
      return "-";
    },
    battery(val) {
      return `${parseFloat(val).toFixed(0)}`;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/base.scss";
.tab_header_select {
  display: none;
  @media #{$phone-down} {
    display: block;
  }
}
.tab_header_custom {
  @media #{$phone-down} {
    display: none;
  }
}
.list_action {
  &:first-child {
    button:hover {
      background-color: $dark-jungle-green;
      color: $light-cyan;
    }
  }
  button.v-btn {
    &.off_line {
      color: $alert;
    }
    &.on_line {
      color: $blue-btn;
    }
  }
}
.ctn_off_data {
  margin-top: 10px;
  span.off_data {
    font-size: 0.85rem;
    text-transform: uppercase;
    padding: 2px 10px;
    border-radius: 4px;
    &.offline {
      background-color: $alert;
      color: $bg-light;
    }
    &.online {
      background-color: $green-btn;
      color: $light-cyan;
    }
  }
}
.style_map {
  display: flex;
  height: 400px;
  z-index: 1;
}
.ctn_bread {
  display: flex;
  flex-direction: column;
  a.bread {
    padding: 5px;
    font-size: 0.9rem;
    color: $color-link;
  }
}
.ctn_chart {
  margin: 20px 0 30px;
  .ctn_flow_chart {
    border: 1px solid #ddd;
    border-radius: 2px;
    overflow: scroll;
    width: 95vw;
    @media #{$tablet-up} {
      overflow: auto;
      width: initial;
    }
    .flow_chart {
      overflow: hidden;
      width: 1200px;
      @media #{$tablet-up} {
        overflow: auto;
        width: initial;
      }
    }
  }
}
.indi_integrator {
  padding: 10px 0;
  h2 {
    padding: 5px 0;
  }
  span {
    &.display {
      display: flex;
      font-size: 0.85rem;
      &.normal {
        width: max-content;
        padding: 4px 10px;
        border-radius: 4px;
        color: #000;
        background-color: $light-cyan;
        font-weight: 600;
      }
      &.alert {
        width: max-content;
        padding: 4px 10px;
        border-radius: 4px;
        font-weight: 600;
        color: #ffff;
        background: $alert;
      }
      &.warning {
        width: max-content;
        padding: 4px 10px;
        border-radius: 4px;
        font-weight: 600;
        color: #000;
        background: #ffdc5c;
      }
      b {
        font-size: 1.5rem;
      }
    }
  }
}
</style>
